<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
                 <el-form-item label="手机账户:" prop="memberMobile">
                     <el-input v-model="dataForm.memberMobile" :readonly="true" placeholder="手机号码"></el-input>
                 </el-form-item>
                 <el-form-item label="会员名称:" prop="memberName">
                     <el-input v-model="dataForm.memberName" :readonly="true" placeholder="会员名称"></el-input>
                 </el-form-item>
                 <el-form-item label="分红优果:" prop="integrationShare">
                     <el-input v-model="dataForm.integrationShare" :readonly="true" placeholder="分红优果"></el-input>
                 </el-form-item>
                 <el-form-item label="设备编码" prop="deviceCode">
                     <el-select v-model="dataForm.deviceCode" placeholder="请选择设备编码">
                         <el-option label="全选" value="" key=""></el-option>
                         <el-option
                                 v-for="item in deviceCodeList"
                                 :key="item.deviceCode"
                                 :label="item.deviceCode"
                                 :value="item.deviceCode">
                         </el-option>
                     </el-select>
                 </el-form-item>
                 <el-form-item label="锁定时长" prop="amount">
                     <el-input-number v-model="dataForm.amount"   placeholder="锁定时长"></el-input-number>
                 </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary"  @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from "lodash/debounce"
    export default {
        data() {
            return {
                visible: false,
                active:0,
                viewStatus:false,
                deviceCodeList:[],
                dataForm: {
                    memberId: '',
                    memberName:'',
                    memberMobile:'',
                    integrationShare:'',
                    memberBalance:0,
                    deviceCode: '',
                    amount:0
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    deviceCode: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    amount: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            init(id) {
                debugger;
                this.visible = true
                //this.active=0
                //this.viewStatus=false;
                this.$nextTick(() => {
                    //this.$refs['dataForm'].resetFields()
                    this.dataForm.id=id;
                    this.getMemberInfo();
                    this.getDeviceList();
                })
            },
            // 获取信息
            getMemberInfo() {
                debugger
                this.$http.get(`/ums/memberbalance/getByMemberId/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm.memberId=res.data.memberId;
                    this.dataForm.memberName=res.data.memberName;
                    this.dataForm.integrationShare=res.data.integrationShare;
                    this.dataForm.memberMobile=res.data.mobileNumber;
                }).catch(() => {
                })
            },
            // 获取信息
            getDeviceList() {
                this.$http.get(`/dms/device/listByMemeberId/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.deviceCodeList=res.data;
                }).catch(() => {

                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function() {
                console.log(this.dataForm.transferMobile);
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }

                    this.$http['post']('/cp/memberLock/dolockBalance', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
